"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable jsx-a11y/control-has-associated-label */
var ChipView = function ChipView(_ref) {
  var filterElement = _ref.filterElement,
      onCloseClick = _ref.onCloseClick;

  var closeHandler = function closeHandler() {
    return onCloseClick(filterElement);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "chip"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: "0",
    onClick: closeHandler,
    onKeyPress: function onKeyPress(e) {
      return e.key === 'Enter' && closeHandler;
    },
    className: "chip__close-button"
  }), filterElement.name);
};

ChipView.propTypes = {
  onCloseClick: _propTypes["default"].func,
  // eslint-disable-next-line react/forbid-prop-types
  filterElement: _propTypes["default"].object.isRequired
};
ChipView.defaultProps = {
  onCloseClick: function onCloseClick() {
    return null;
  }
};
var _default = ChipView;
exports["default"] = _default;